import React from "react";

import { LoadingSpinnerIcon } from "../Icons/LoadingSpinnerIcon";

import { ButtonSize, ButtonStyle } from "./Button.types";
import { classNamesBySizeAndStyle } from "./Button.utils";

export type ButtonProps = React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & {
    size?: ButtonSize;
    buttonStyle?: ButtonStyle;
    isLoading?: boolean;
};

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
    ({ className, type, children, size, buttonStyle, isLoading, ...props }, ref) => (
        <button
            ref={ref}
            {...props}
            type={type || "button"}
            disabled={isLoading || props.disabled}
            className={[
                classNamesBySizeAndStyle(size ?? ButtonSize.Medium, buttonStyle ?? ButtonStyle.Primary),
                className || "",
            ].join(" ")}
        >
            {isLoading ? (
                <>
                    <LoadingSpinnerIcon size={4} classNames="me-3" />
                    Loading...
                </>
            ) : (
                children
            )}
        </button>
    ),
);

Button.displayName = "Button";
